import { map, toString } from 'lodash/fp';

import getImageAttributes from '../../../cms/utils/get-image-attributes';
import uncapFpIterator from '../../../../utils/uncap-fp-iterator';

// @ts-expect-error - Automatic, Please fix when editing this file
const mapStepsContent = (steps) =>
  uncapFpIterator(map)(
    // @ts-expect-error - Automatic, Please fix when editing this file
    ({ description, imageObject, name, urlObject }, index) => ({
      details: description,
      image: getImageAttributes({ height: 156, imageObject }),
      title: name,
      titlePrefix: toString(index + 1),
      urlObject,
    }),
    steps,
  );

export default mapStepsContent;
